export const VACATION_SCRIPT_NAME = "vacation";
export const MAIN_SCRIPT_NAME = "main";
export const VACATION_MARKER = '# --- user rules below ---';
const INCLUDE_RE = /^([ \t]*)(#)?[ \t]*include[ \t]+:personal[ \t]+"vacation"[ \t]*;[ \t]*$/gm;
const REQUIRE_INCLUDE_RE = /require\s*\[\s*([^\]]*)\s*\]\s*;/gi;
export function escapeSieveQuoted(value) {
    return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}
export function generateVacationScript(settings) {
    const days = Number.isFinite(settings.days) && settings.days > 0 ? Math.floor(settings.days) : 7;
    const parts = ['require ["vacation"];', "vacation"];
    parts.push(`:days ${days}`);
    if (settings.subject.trim()) {
        parts.push(`:subject "${escapeSieveQuoted(settings.subject.trim())}"`);
    }
    const addresses = settings.addresses.map((a) => a.trim()).filter(Boolean);
    if (addresses.length === 1) {
        parts.push(`:addresses "${escapeSieveQuoted(addresses[0])}"`);
    }
    else if (addresses.length > 1) {
        const list = addresses.map((a) => `"${escapeSieveQuoted(a)}"`).join(", ");
        parts.push(`:addresses [${list}]`);
    }
    const message = settings.message.replace(/\r\n/g, "\n");
    parts.push("text:");
    return `${parts.join(" ")}\n${message}${message.endsWith("\n") ? "" : "\n"}.\n;`;
}
export function parseVacationScript(content) {
    const trimmed = content.trim();
    if (!/\bvacation\b/i.test(trimmed)) {
        return null;
    }
    const daysMatch = trimmed.match(/:days\s+(\d+)/i);
    const subjectMatch = trimmed.match(/:subject\s+"((?:\\.|[^"\\])*)"/i);
    const addresses = [];
    const addrList = trimmed.match(/:addresses\s+\[([^\]]*)\]/i);
    if (addrList) {
        for (const m of addrList[1].matchAll(/"((?:\\.|[^"\\])*)"/g)) {
            addresses.push(m[1].replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
        }
    }
    else {
        const addrOne = trimmed.match(/:addresses\s+"((?:\\.|[^"\\])*)"/i);
        if (addrOne) {
            addresses.push(addrOne[1].replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
        }
    }
    let message = "";
    const textMatch = trimmed.match(/\btext:\s*\n([\s\S]*?)\n\.\s*;/i);
    if (textMatch) {
        message = textMatch[1];
    }
    else {
        const quoted = trimmed.match(/\bvacation\b[\s\S]*?"((?:\\.|[^"\\])*)"\s*;/i);
        if (quoted) {
            message = quoted[1].replace(/\\"/g, '"').replace(/\\\\/g, "\\");
        }
    }
    return {
        subject: subjectMatch
            ? subjectMatch[1].replace(/\\"/g, '"').replace(/\\\\/g, "\\")
            : "",
        message,
        days: daysMatch ? parseInt(daysMatch[1], 10) : 7,
        addresses,
    };
}
export function isVacationIncludeEnabled(content) {
    INCLUDE_RE.lastIndex = 0;
    let match;
    while ((match = INCLUDE_RE.exec(content)) !== null) {
        if (!match[2]) {
            return true;
        }
    }
    return false;
}
function ensureRequireInclude(content) {
    REQUIRE_INCLUDE_RE.lastIndex = 0;
    const match = REQUIRE_INCLUDE_RE.exec(content);
    if (!match) {
        const header = 'require ["include"];\n';
        return header + (content.startsWith("\n") ? content.slice(1) : content);
    }
    const inner = match[1];
    const tokens = [...inner.matchAll(/"([^"]+)"/g)].map((m) => m[1]);
    if (tokens.some((t) => t.toLowerCase() === "include")) {
        return content;
    }
    tokens.push("include");
    const replacement = `require [${tokens.map((t) => `"${t}"`).join(", ")}];`;
    return content.slice(0, match.index) + replacement + content.slice(match.index + match[0].length);
}
function stripExistingVacationIncludes(content) {
    return content.replace(INCLUDE_RE, "").replace(/\n{3,}/g, "\n\n");
}
export function setVacationInclude(content, enabled) {
    let next = ensureRequireInclude(stripExistingVacationIncludes(content).trimStart());
    const includeLine = enabled
        ? 'include :personal "vacation";'
        : '# include :personal "vacation";';
    // Place include immediately after the first require [...] ;
    const requireMatch = next.match(/require\s*\[[^\]]*\]\s*;/);
    if (requireMatch && requireMatch.index !== undefined) {
        const insertAt = requireMatch.index + requireMatch[0].length;
        const before = next.slice(0, insertAt);
        let after = next.slice(insertAt).replace(/^\n*/, "\n");
        if (!after.includes(VACATION_MARKER) && after.trim().length > 0) {
            // Keep marker only as documentation for generated wrappers; don't force into arbitrary scripts.
        }
        next = `${before}\n${includeLine}${after.startsWith("\n") ? "" : "\n"}${after}`;
    }
    else {
        next = `require ["include"];\n${includeLine}\n${next}`;
    }
    return next.replace(/\n{3,}/g, "\n\n").trimEnd() + "\n";
}
export function createMainWrapper(enabled) {
    const includeLine = enabled
        ? 'include :personal "vacation";'
        : '# include :personal "vacation";';
    return `require ["include"];\n${includeLine}\n${VACATION_MARKER}\n`;
}
